<template>
  <div>
    <v-row>
      <v-col cols="12" md="8">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">
                {{ $t('platform') }}
              </th>
              <th class="text-left">
                {{ $t('date') }}
              </th>
              <th class="text-center">
                {{ $t('payment') }}
              </th>
              <th class="text-right">
                {{ $t('amount') }}
              </th>
              <th class="text-right">
                {{ $t('download') }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="invoice in invoices" :key="invoice.id">
              <td class="text-left">
                {{ $module.all[invoice.module].display.name }}
              </td>
              <td class="text-left">{{ $helpers.present.date(invoice.date) }}</td>
              <td class="text-center">
                <v-chip small color="success" v-if="invoice.amount_off === 0">Payé</v-chip>
                <v-chip small color="warning" v-else>Non payé</v-chip>
              </td>
              <td class="text-right">{{ $helpers.present.currency(invoice.total / 100) }}</td>
              <td class="text-right">
                <v-btn icon color="primary" target="_blank" :href="invoice.link">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>

        <p class="text-center mt-4 grey--text text--darken-1">
        <span v-if="this.$api.loading('account/customer/invoices')">
          {{ $t('billing.loading') }}
        </span>
          <span v-else-if="invoices.length === 0">
            {{ $t('billing.empty') }}
        </span>
        </p>
      </v-col>
      <v-col cols="12" md="4">
        <v-row>
          <v-col cols="12">
            <a-billing-customer-widget></a-billing-customer-widget>
          </v-col>
          <v-col cols="12">
            <a-billing-payment-method-widget></a-billing-payment-method-widget>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ABillingWidget',
  data() {
    return {
      invoices: []
    }
  },
  async mounted () {
    this.invoices = (await this.$api.get('account/customer/invoices')).data
  }
}
</script>

<i18n>
{
	"en": {
		"amount": "Amount",
		"billing": {
			"empty": "Your account has no invoice.",
			"loading": "Loading your invoices ..."
		},
		"date": "Date",
		"download": "Download",
		"payment": "Payment status",
		"platform": "Platform"
	},
	"es": {
		"amount": "Cantidad",
		"billing": {
			"empty": "Su cuenta no tiene factura.",
			"loading": "Cargando sus facturas ..."
		},
		"date": "Fecha",
		"download": "Descargar",
		"payment": "Estado de pago",
		"platform": "Plataforma"
	},
	"fr": {
		"amount": "Montant",
		"billing": {
			"empty": "Votre compte ne dispose d'aucune facture.",
			"loading": "Chargement de vos factures ..."
		},
		"date": "Date",
		"download": "Télécharger",
		"payment": "Etat du paiement",
		"platform": "Plateforme"
	},
	"it": {
		"amount": "Importo",
		"billing": {
			"empty": "Il tuo account non ha nessuna fattura.",
			"loading": "Caricamento delle tue fatture ..."
		},
		"date": "Data",
		"download": "Scarica",
		"payment": "Stato del pagamento",
		"platform": "Piattaforma"
	},
	"pt": {
		"amount": "Montante",
		"billing": {
			"empty": "A sua conta não tem nenhuma fatura.",
			"loading": "A carregar as suas faturas ..."
		},
		"date": "Data",
		"download": "Transferir",
		"payment": "Estado do pagamento",
		"platform": "Plataforma"
	},
	"pl": {
		"amount": "Kwota",
		"billing": {
			"empty": "Twoje konto nie ma żadnej faktury.",
			"loading": "Ładowanie Twoich faktur ..."
		},
		"date": "Data",
		"download": "Pobierz",
		"payment": "Status płatności",
		"platform": "Platforma"
	}
}
</i18n>



